import i18n from './index';

type NsModule = { default: Record<string, unknown> };

const ruModules = import.meta.glob<NsModule>('./ru/{client,admin,courier,platform}.json');
const kyModules = import.meta.glob<NsModule>('./ky/{client,admin,courier,platform}.json');

const loaded = new Set<string>();

/** Fetches a lazily-split namespace's ru+ky bundles once and registers them with i18next. */
export async function loadNamespace(
  ns: 'client' | 'admin' | 'courier' | 'platform',
): Promise<void> {
  if (loaded.has(ns)) return;
  loaded.add(ns);
  const [ru, ky] = await Promise.all([
    ruModules[`./ru/${ns}.json`]!(),
    kyModules[`./ky/${ns}.json`]!(),
  ]);
  i18n.addResourceBundle('ru', ns, ru.default, true, true);
  i18n.addResourceBundle('ky', ns, ky.default, true, true);
}
